import React from "react";
import { Avatar, Breadcrumb, Button, Card, Col, Divider, Drawer, Form, Input, Layout, Modal, Pagination, Row, Select, Spin, Switch, Tag, Timeline, Typography, Upload, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { IoCameraOutline, IoLockOpen, IoPencil, IoReturnUpBackOutline, IoTrash } from "react-icons/io5";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { POST_API, POST_CATCH, getToken, getUPLOADAPI, titleWeb, verifyConfig } from "../../../services/api";

// COMPONENTS
import Table from '../../../components/Table';

// CONTROLLER
import Page403 from '../../Controller/Page403';
import ReactInputMask from "react-input-mask";

class AdminAtualizacoes extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        tribunal: null,
        table_load: true,
        table_filter: null,
        table_sorter: { order: 'descend', columnKey: 'DATETIME_INSERT' },
        table_pagination: { current: 1, total: 0, limit: 10 },
        table_data: [],
        processo: '',
        prev: '',
        next: '',
        itemSelect: null,
        search: ''
    }

    back = "/painel/atualizacoes";

    routes = [
        {title: <Link to={this.back}>Atualizações</Link>}
    ]

    componentDidMount = () => {
        titleWeb('Atualizações')
        this.onRenderData()
    }
    
    // LOAD DATA
    onRenderData = () => {
        this.setState({table_load: true })
        setTimeout(async () => {
            POST_API('/news/search.php', { token: getToken(), pagination: JSON.stringify(this.state.table_pagination), filter: JSON.stringify(this.state.table_filter), sorter: JSON.stringify(this.state.table_sorter), search: this.state.search, type: 'list' }).then(rs => rs.json()).then(res => {
                if (res.return) {
                    this.setState({
                        _plan: res.option,
                        table_data: res.data,
                        table_pagination: {
                            ...this.state.table_pagination,
                            total: res.summary.QTDE
                        }
                    })
                } else {
                    message.error({ content: res.msg, key: 'screen' })
                }
            }).catch(() => POST_CATCH()).finally(() => this.setState({table_load: false }))
        }, 500);
    }

     onPaginationChange = (page, size) => {
        this.setState({
            table_pagination: {
                ...this.state.table_pagination,
                current: page,
                limit: size
            }
        })
        this.onRenderData()
    }

    onPrev = () => {
        this.onView(this.state.pagination.current - 1, 'prev')
    }

    onNext = () => {
        this.setState({
            prev: this.state.data[1].sort[0],
        })
        this.onView(this.state.pagination.current + 1, 'next')
    }


    render = () => {

        return (
            <Layout>
                <Layout.Content className={`admin-container`}>
                    <Row gutter={[8,8]} align={'middle'}>
                        <Col span={18}>
                            <Breadcrumb items={this.routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            
                        </Col>
                        <Col span={24}>
                            <Card>
                                <Row gutter={[8,8]}>
                                    <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                                        <Input.Search size="large" enterButton onSearch={this.onRenderData} value={this.state.search} onChange={(e) => this.setState({search: e.target.value})} placeholder="Pesquisar publicações"  style={{width: '100%'}} />
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                        { this.state.table_load ? <Col span={24}><Card><center><Spin /></center></Card></Col> : !(this.state.table_data.length > 0) ? <Col span={24}><Card>Nenhuma publicação encontrada</Card></Col> : this.state.table_data.map((item, index) => (
                            <Col span={24} key={index}>
                                <Card>
                                    <Row gutter={[16,16]}>
                                        <Col span={24}>
                                            <Typography style={{fontWeight: 700, fontSize: 16}}>{item.NAME}</Typography>
                                            <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Advogado(a):</span> {item.LAWYER}</Typography>
                                            { item.OAB_NUMBER ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Número da OAB:</span> {item.OAB_NUMBER}</Typography> : null }
                                            <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Data processamento/pesquisa:</span> {item.DATE_PROCESS} ({item.SEARCH})</Typography>
                                        </Col>
                                        { item.POSTS.length > 0 ? item.POSTS.map((post, inx) => (
                                            <Col span={24} key={inx}>
                                                <Divider  style={{marginTop: 10}}/>
                                                <Typography style={{fontWeight: 700}}>Publicação {post.POST}</Typography>
                                                { post.PROCESS_NUMBER ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Processo:</span> {post.PROCESS_NUMBER}</Typography> : null }
                                                { post.DATE_AVAILABILITY ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Data da disponibilização:</span> {post.DATE_AVAILABILITY}</Typography> : null }
                                                { post.DATE_PUBLICATION ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Data da publicação:</span> {post.DATE_PUBLICATION}</Typography> : null }
                                                { post.NEWSPAPER ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Jornal:</span> {post.NEWSPAPER}</Typography> : null }
                                                { post.PAGE ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Página:</span> {post.PAGE}</Typography> : null }
                                                { post.NOTEBOOK ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Caderno:</span> {post.NOTEBOOK}</Typography> : null }
                                                { post.LOCATION ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Local:</span> {post.LOCATION}</Typography> : null }
                                                { post.COURT ? <Typography style={{fontSize: 12}}><span style={{fontWeight: 700}}>Vara:</span> {post.COURT}</Typography> : null }
                                                <div dangerouslySetInnerHTML={{ __html: post.PUBLICATION }} />
                                                {/* { ht post.PUBLICATION } */}
                                            </Col>
                                        )) : (
                                            <Col span={24}>Não foi localizada qualquer publicação a ser enviada a sua caixa de e-mail na pesquisa realizada nesta data.</Col>
                                        ) }
                                        {/*<Col span={24}>
                                            <Typography className="datajud-title">Última atualização</Typography>
                                            <Typography className="datajud-text">{this.formatData(item._source.dataHoraUltimaAtualizacao)}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Data do ajuizamento</Typography>
                                            <Typography className="datajud-text">{this.formatData(item._source.dataAjuizamento)}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Orgão julgador</Typography>
                                            <Typography className="datajud-text">{item._source.orgaoJulgador.codigo} - {item._source.orgaoJulgador.nome}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Classe</Typography>
                                            <Typography className="datajud-text">{item._source.classe.codigo} - {item._source.classe.nome}</Typography>
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-title">Assuntos</Typography>
                                            { item._source.assuntos.map((assunto, assuntoIndex) => (
                                                <Typography key={assuntoIndex} className="datajud-text">{assunto.codigo} - {assunto.nome}</Typography>
                                            )) }
                                        </Col>
                                        <Col span={24}>
                                            <Typography className="datajud-clique">Clique para abrir a timeline</Typography>
                                        </Col> */}
                                    </Row>
                                </Card>
                            </Col>
                        ))}
                        <Col span={24}>
                            <Row justify="end">
                                <Pagination size="small" current={this.state.table_pagination.current} defaultCurrent={this.state.table_pagination.current} total={this.state.table_pagination.total} onChange={this.onPaginationChange}/>
                            </Row>
                        </Col>
                    </Row>
                </Layout.Content>
            </Layout>
        )

    }

}

export default AdminAtualizacoes;